import { HTMLAttributes, forwardRef } from "react";
import { cx } from "../../utils/cx";
import styles from "./SelectionList.module.scss";

export interface SelectionListProps extends HTMLAttributes<HTMLUListElement> {
    /** Optional card-like border around the list (menu / panel style). */
    bordered?: boolean;
}

/**
 * Treez DS — SelectionList
 *
 * Semantic `<ul>` wrapper for `ListItem` (`as="li"`) or `ChecklistItem` groups.
 * Pair with `role="listbox"` + `aria-multiselectable` when implementing
 * listbox patterns.
 */
export const SelectionList = forwardRef<HTMLUListElement, SelectionListProps>(
    function SelectionList(
        { bordered = false, className, children, ...rest },
        ref,
    ) {
        return (
            <ul
                className={cx(
                    styles.root,
                    bordered && styles.bordered,
                    className,
                )}
                data-ui="selection-list"
                ref={ref}
                {...rest}
            >
                {children}
            </ul>
        );
    },
);

SelectionList.displayName = "SelectionList";
